import { TableRow } from '@code/innovance-react-ui-kit';
import { Document } from 'src/front/api/apiInstance';

import { UploadDocumentFormData } from 'src/front/components/document/UploadDocumentModal';
import { PlasticCardDocumentUploadFormData } from 'src/front/components/PlasticCardDocumentUploadForm';
import { displayDocument } from './domUtils';

const previewDocumentAction = async (
  documents: UploadDocumentFormData[] | PlasticCardDocumentUploadFormData[],
  item?: TableRow
): Promise<void> => {
  const document = documents.find((doc) => doc.documentId === item?.id);
  if (document) {
    const { documentId, documentName } = document;
    const { data } = await Document.getDocumentData({ documentId, documentName });
    if (data.result === 'OK') {
      displayDocument(data.documentData);
    }
  }
};

export default previewDocumentAction;
